import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export function PublicHeader() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [mobileOpen]);

  return (
    <nav
      className="sticky top-0 z-50 bg-transparent border-b border-transparent"
    >
      <div className="px-2 sm:px-3 lg:px-4">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center">
            <img
              src="/logo-horizontal.png"
              alt="CogniPrint"
              className="h-12 sm:h-16 w-auto"
            />
          </Link>

          <div className="hidden md:flex items-center gap-5">
            <Link to="/how-it-works" className="text-sm text-content-secondary hover:text-content transition-colors font-body">
              How It Works
            </Link>
            <Link to="/pricing" className="text-sm text-content-secondary hover:text-content transition-colors font-body">
              Pricing
            </Link>
            <Link to="/for-teams" className="text-sm text-content-secondary hover:text-content transition-colors font-body">
              For Teams
            </Link>
            <Link to="/login" className="text-sm text-content-secondary hover:text-content transition-colors font-body">
              Log In
            </Link>
            <Link to="/signup" className="text-sm px-4 py-2 rounded bg-indigo-500 text-white hover:bg-[#7E70EF] transition-colors font-body">
              Sign Up
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={mobileOpen}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-content-secondary hover:text-content hover:bg-dark-surface transition-colors cursor-pointer"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <>
          <div
            className="fixed inset-0 top-24 z-40 bg-black/60 backdrop-blur-sm md:hidden"
            onClick={() => setMobileOpen(false)}
          />
          <div className="fixed inset-x-0 top-24 z-50 border-b border-dark-border bg-dark-surface md:hidden max-h-[calc(100vh-6rem)] overflow-y-auto">
            <div className="px-4 py-4 flex flex-col gap-1">
              <MobileLink to="/how-it-works" label="How It Works" />
              <MobileLink to="/pricing" label="Pricing" />
              <MobileLink to="/for-teams" label="For Teams" />
              <div className="h-px bg-dark-border my-2" />
              <MobileLink to="/login" label="Log In" />
              <Link
                to="/signup"
                onClick={() => setMobileOpen(false)}
                className="block mt-2 text-center text-sm px-4 py-3 rounded-lg bg-indigo-500 text-white hover:bg-[#7E70EF] transition-colors font-body"
              >
                Sign Up — free
              </Link>
            </div>
          </div>
        </>
      )}
    </nav>
  );
}

function MobileLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="block px-3 py-3 rounded-lg hover:bg-dark-hover transition-colors"
    >
      <div className="text-sm font-body font-semibold text-content">{label}</div>
    </Link>
  );
}
